import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar, private translate: TranslateService) { }

  showUnknownError(error: any): void {
    let message: string | undefined

    if (typeof error.error === 'string')
      message = error.error

    // http error
    else if (error instanceof HttpErrorResponse)
      message = error.message

    // exception with details
    else if (error.error?.exceptionType && error.error.exceptionMessage) {
      message = `${error.error.exceptionType}: ${error.error.exceptionMessage}`

      if (error.error.stackTrace)
        message += '\n' + error.error.stackTrace
    }
    // common error message
    else if (error.error?.message)
      message = error.error.message

    if (error.error?.messageDetail)
      message += ' ' + error.error.messageDetail

    if (!message)
      message = this.translate.instant('ERROR.UNKNOWN', { error })

    this.snackBar.open(message!, this.translate.instant('CLOSE'), { panelClass: ['error', 'multiline'] })
  }
}
